<app-modal-container
  [title]="header"
  [buttons]="modalButtons"
  [spinnerProps]="spinnerProps"
  [bigSize]="false"
  [applyActivated]="thinkTwiceInput === THINK_TWICE"
  [showWhiteSpace]="showWhiteSpace"
  [innerModal]="innerModal"
  [titleDirection]="'start'"
  (closeButtonClicked)="close()"
  (applyButtonClicked)="checkThinkTwicePassword()"
  (dismissButtonClicked)="close()">
  <ng-content></ng-content>
  <div class="flex flex-col items-start gap-[0.5rem] font-4">
    @if (showIUnderstand) {
      <span class="bold600">I understand that:</span>
      @if (mainText && useStandardList) {
        <app-modal-delete-list
          [showIcons]="true"
          [textList]="mainText"
        />
      }
    } @else {
      <span class="bold600">{{customUnderstandString}}</span>
    }
    @if (showInput) {
      <span class="flex gap-[0.3125rem]">Confirm by typing
        <span
          id="{{ID_FOR_COPY}}"
          data-qa="copy-to-clipboard"
          class="cursor-pointer flex gap-[0.3125rem]"
          (click)="copyToClipboard()"
          (mouseenter)="activateToolTip()"
          (mouseleave)="toolTipSettings.show = false">
          <span>
            <app-all-icons [iconNameAndStyling]="'copy.svg; red-11'"/>
          </span>
          <span class="red-11 bold600">{{THINK_TWICE}}</span>
        </span>
        below.
      </span>
      <app-input
        data-qa="modal-dialog-password-input"
        class="flex w-[100%] pt-[0.5rem]"
        [inputID]="'modalDialogInput'"
        [type]="''"
        [placeholder]="THINK_TWICE"
        [hideText]="false"
        [bottomText]="isThinkTwiceInvalid ? 'Entered value is not equal to \'' + THINK_TWICE + '\'' : ''"
        [additionalClass]="isThinkTwiceInvalid ? 'error' : ''"
        [(input)]="thinkTwiceInput"
      />
    }
  </div>
  @if (toolTipSettings?.show) {
    <app-tooltip
      [title]="toolTipSettings.title"
      [isParentPositionRelative]="true"
      [coordinates]="toolTipSettings.coordinates"
    />
  }
</app-modal-container>

